import { render, staticRenderFns } from "./AdditionalFindingsSettings.vue?vue&type=template&id=21ba373b&scoped=true&"
import script from "./AdditionalFindingsSettings.vue?vue&type=script&lang=js&"
export * from "./AdditionalFindingsSettings.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalFindingsSettings.vue?vue&type=style&index=0&id=21ba373b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ba373b",
  null
  
)

export default component.exports